import React, { Component } from "react";
import "./SwipeableListItem.css";
import LowAmountCheckBox from "../LowAmountCheckBox/LowAmountCheckBox";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import EditItemListComponent from "../EdiItemListComponent/EditItemListComponent";
import { store } from "../../../Store/store";
import { COLORS } from "../../../Theme/variables";

let langData = require("../../../Data/language.json");

class SwipeableListItem extends Component {
  constructor(props) {
    super(props);

    this.listElement = null;
    this.wrapper = null;
    this.background = null;
    this.dragArrow = null;

    this.onMouseMove = this.onMouseMove.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onDragStartMouse = this.onDragStartMouse.bind(this);
    this.onDragStartTouch = this.onDragStartTouch.bind(this);
    this.onDragEndMouse = this.onDragEndMouse.bind(this);
    this.onDragEndTouch = this.onDragEndTouch.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.updatePosition = this.updatePosition.bind(this);
    this.onSwiped = this.onSwiped.bind(this);
    this.targetElement = null;

    this.state = {
      clicked: false,
      deleteText: "",
      removeAll: false,
      editItem: false,
    };
  }

  // DOM Refs
  listElement;
  wrapper;
  background;
  dragArrow;

  startTime;
  fpsInterval = 1000 / 60;

  dragStartX = 0;
  left = 0;
  dragged = false;

  dragStartY = 0;
  down = 0;
  up = 0;

  expandedContent = null;
  numberOfDates = 1;

  lastTouchEnd = 0;

  delText = langData[this.props.language].listItem.delete.delete;
  delOneText = langData[this.props.language].listItem.delete.delete1;
  delAllText = langData[this.props.language].listItem.delete.delete2;

  componentDidMount() {
    window.addEventListener("mouseup", this.onDragEndMouse);
    window.addEventListener("touchend", this.onDragEndTouch);
  }

  componentWillUnmount() {
    window.removeEventListener("mouseup", this.onDragEndMouse);
    window.removeEventListener("touchend", this.onDragEndTouch);
    if (store.getState().firebase.editingItem) {
      this.props.toggleEditState();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.expanded !== prevProps.expanded) {
      if (this.props.expanded) {
        this.expandRow();
      } else {
        this.collapseRow();
      }
    }

    if (this.props.currentScreen === "trash") {
      this.numberOfDates = this.props.dates.length;
    }
  }

  expandRow = () => {
    if (this.props.currentScreen === "inventory") {
      this.wrapper.style.height = "120px";
    } else {
      let divHeight = 150 + this.numberOfDates * 40;
      this.wrapper.style.height = `${divHeight}px`;
    }
  };

  collapseRow = () => {
    if (this.state.editItem) {
      this.setState({ editItem: false }, () => {
        this.renderExpandedContent();
      });
    }
    if (store.getState().firebase.editingItem) {
      this.props.toggleEditState();
    }

    this.wrapper.style.height = "60px";
    this.expandedContent = null;
  };

  onDragStartMouse(evt) {
    this.onDragStart(evt.clientX, evt.clientY);
    window.addEventListener("mousemove", this.onMouseMove);
  }

  onDragStartTouch(evt) {
    const touch = evt.targetTouches[0];
    this.onDragStart(touch.clientX, touch.clientY);
  }

  onDragStart(clientX, clientY) {
    window.addEventListener("touchmove", this.onTouchMove);

    this.dragged = true;

    this.dragStartX = clientX;
    this.dragStartY = clientY;

    // Add this:
    this.listElement.className = "ListItem";

    requestAnimationFrame(this.updatePosition);
  }

  onMouseMove(evt) {
    const left = evt.clientX - this.dragStartX;

    if (evt.clientY > this.dragStartY) {
      this.down = evt.clientY - this.dragStartY;
      this.up = 0;
    } else {
      this.up = this.dragStartY - evt.clientY;
      this.down = 0;
    }

    if (left < 0) {
      this.left = left;
    }
  }

  onTouchMove(evt) {
    const touch = evt.targetTouches[0];
    const left = touch.clientX - this.dragStartX;
    if (touch.clientY > this.dragStartY) {
      this.down = touch.clientY - this.dragStartY;
      this.up = 0;
    } else {
      this.up = this.dragStartY - touch.clientY;
      this.down = 0;
    }
    if (left < 0) {
      this.left = left;
    }
  }

  onDragEndMouse(evt) {
    window.removeEventListener("mousemove", this.onMouseMove);
    this.onDragEnd();
  }

  onDragEndTouch(evt) {
    const now = new Date().getTime();
    if (now - this.lastTouchEnd <= 300) {
      evt.preventDefault();
    }
    this.lastTouchEnd = now;
    window.removeEventListener("touchmove", this.onTouchMove);
    this.onDragEnd();
  }

  toggleExpand = () => {
    var threshold = 0.75;

    if (this.props.currentScreen === "inventory") {
      threshold = 0.55;
    }

    if (this.props.currentScreen !== "shopping") {
      if (this.dragStartX < window.innerWidth * threshold) {
        if (!this.props.expanded && !store.getState().firebase.editingItem) {
          this.props.collapseAllExcept(this.props.id.toString());
          this.renderExpandedContent();
        } else if (!store.getState().firebase.editingItem) {
          this.props.collapseAll();
        }
      }
    }
  };

  extractDates = (inputDates) => {
    var itemDates = [];
    var key = 0;

    inputDates.forEach((item) => {
      let date = new Date(item);

      let month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }

      let day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }

      let hours = date.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }

      let minutes = date.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }

      let seconds = date.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds;
      }

      let formatted_date = date.getFullYear() + "-" + month + "-" + day;
      let formatted_time = hours + ":" + minutes + ":" + seconds;
      itemDates.push(
        <div className="row" key={key}>
          {" "}
          <div className="container-fluid historyColumn col-6">
            <p className="historyText">{formatted_date}</p>
          </div>
          <div className="container-fluid historyColumn col-6">
            <p className="historyText">{formatted_time}</p>
          </div>
        </div>
      );
      key++;
    });
    return itemDates;
  };

  renderExpandedContent = () => {
    if (this.props.currentScreen === "inventory") {
      if (this.state.editItem === true) {
        this.iconButton = (
          <Button id="editItemButton" onClick={() => this.onEditButtonClick()}>
            {" "}
            <img
              className="editIcon"
              src={require("../../../Images/Icons/No.svg")}
              alt="editIcon"
            ></img>{" "}
          </Button>
        );
      }
      if (this.state.editItem === false) {
        this.iconButton = (
          <Button id="editItemButton" onClick={() => this.onEditButtonClick()}>
            {" "}
            <img
              className="editIcon"
              src={require("../../../Images/Icons/edit.svg")}
              alt="editIcon"
            ></img>{" "}
          </Button>
        );
      }
      this.expandedContent = (
        <div className="row align-items-center">
          <div className="container col-4 listInfo">
            <Link
              className="moreInfoLink"
              onClick={() => this.props.onItemScreen()}
            >
              <p className="moreInfoText">
                {langData[this.props.language].listItem.moreInfo}
              </p>
            </Link>
          </div>

          <div
            className="container col-5"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div className="lowAmountCell">
              <LowAmountCheckBox
                amount={this.props.amount}
                onEditItemSlider={(amount) =>
                  this.props.onEditItemSlider(amount)
                }
                language={store.getState().firebase.language}
              />
            </div>
          </div>

          <div className="container col-2 listBtn">{this.iconButton}</div>
        </div>
      );
      this.forceUpdate();
    } else if (this.props.currentScreen === "trash") {
      var itemDates = [];

      if (typeof this.props.dates === "string") {
        // If dates only contains one date, it's in string form and not an array
        itemDates = this.extractDates([this.props.dates]);
      } else {
        // If dates contains several dates, it's in array form
        itemDates = this.extractDates(this.props.dates);
      }

      this.expandedContent = (
        <div className="row">
          <div
            className="container-fluid historyContainer expanded"
            onClick={() => this.props.collapseAll()}
          >
            <div
              className="container-fluid"
              style={{
                textAlign: "center",
                marginBottom: "7px",
                marginTop: "7px",
              }}
            >
              <h6>{langData[this.props.language].trash.history}</h6>
            </div>
            <hr />
            <div className="row">
              <div className="container-fluid historyColumn col-6">
                <h6>{langData[this.props.language].trash.date}</h6>
              </div>
              <div className="container-fluid historyColumn col-6">
                <h6>{langData[this.props.language].trash.time}</h6>
              </div>
            </div>
            {itemDates}
          </div>
        </div>
      );
      this.forceUpdate();
    } else {
      //TODO: IF WE WANT TO SHOW ANYTHING ON EXPAND IN SHOPPING, THIS IS BLOCKED AT LINE 151 AT THE MOMENT
    }
  };

  onEditButtonClick = () => {
    if (this.state.editItem === true) {
      this.setState({ editItem: false }, () => {
        this.renderExpandedContent();
      });
      this.props.toggleEditState();
    } else {
      this.setState({ editItem: true }, () => {
        this.renderExpandedContent();
      });
      this.props.toggleEditState();
    }
  };

  onDragEnd() {
    if (this.dragged) {
      this.dragged = false;

      const threshold = this.props.threshold || 0.3;
      if (this.left < this.listElement.offsetWidth * threshold * -1) {
        // A swipe on an Item is happening
        if (this.state.removeAll) {
          this.left = 0;
          this.onSwiped();
        } else if (
          this.props.qty === 1 &&
          !store.getState().firebase.editingItem
        ) {
          this.left = -this.listElement.offsetWidth * 2;
          this.wrapper.style.maxHeight = 0;
          this.onSwiped();
        } else {
          this.left = 0;
          this.onSwiped();
        }
      } else if (this.left === 0) {
        // A click on an Item has happened
        try {
          if (this.up < 5 && this.down < 5) {
            if (!this.state.clicked) {
              this.toggleExpand();
              this.setState({ clicked: true });
            } else {
              this.setState({ clicked: false });
            }
          }
        } catch {}
      } else {
        // Neither click or swipe intended
        this.left = 0;
      }

      try {
        this.listElement.className = "BouncingListItem";
        this.listElement.style.transform = `translateX(${this.left}px)`;
      } catch {}
    }
    this.up = 0;
    this.down = 0;
  }

  onSwiped() {
    if (this.props.onSwipe) {
      if (!store.getState().firebase.editingItem) {
        this.props.onSwipe(this.state.removeAll);
      }
    }
  }

  updatePosition() {
    if (this.listElement) {
      if (store.getState().firebase.editingItem) {
        if (this.state.deleteText !== "You cannot delete items while editing") {
          this.setState({
            deleteText: "You cannot delete items while editing",
            removeAll: false,
          });
          this.background.style.backgroundColor = "#75AC4A";
        }
      } else if (-1 * this.left < window.innerWidth * 0.3) {
        if (this.state.deleteText !== "<<") {
          this.setState({ deleteText: "<<", removeAll: false });
          this.background.style.backgroundColor = COLORS.secondary;
          this.dragArrow.style.borderRight = `10px solid ${COLORS.secondary}`;
        }
      } else if (-1 * this.left < window.innerWidth * 0.65) {
        if (this.state.deleteText !== this.delOneText) {
          this.setState({ deleteText: this.delOneText, removeAll: false });
          this.background.style.backgroundColor = "rgb(249, 83, 34)";
          this.dragArrow.style.borderRight = "10px solid rgb(249, 83, 34)";
        }
      } else {
        if (this.state.deleteText !== this.delAllText) {
          this.setState({ deleteText: this.delAllText, removeAll: true });
          this.background.style.backgroundColor = "rgb(249, 21, 34)";
          this.dragArrow.style.borderRight = "10px solid rgb(249, 21, 34)";
        }
      }
    }

    try {
      if (this.dragged) requestAnimationFrame(this.updatePosition);

      const now = Date.now();
      const elapsed = now - this.startTime;

      this.listElement.style.transform = `translateX(${this.left}px)`;

      if (this.dragged && elapsed > this.fpsInterval) {
        this.listElement.style.transform = `translateX(${this.left}px)`;

        const opacity = (Math.abs(this.left) / 100).toFixed(2);
        if (
          opacity < 1 &&
          opacity.toString() !== this.background.style.opacity
        ) {
          this.background.style.opacity = opacity.toString();
        }
        if (opacity >= 1) {
          this.background.style.opacity = "1";
        }

        this.startTime = Date.now();
      }
    } catch {}
  }

  render() {
    if (this.state.editItem === false) {
      this.firstRow = this.props.children;
    } else {
      this.firstRow = (
        <EditItemListComponent
          item={this.props.item}
          onEditButtonClick={this.onEditButtonClick}
          onEditInventoryItem={(newItem) =>
            this.props.onEditInventoryItem(newItem)
          }
        />
      );
    }

    return (
      <div className="Wrapper" ref={(div) => (this.wrapper = div)}>
        <div ref={(div) => (this.background = div)} className="Background">
          {this.props.background ? (
            this.props.background
          ) : (
            <span>
              {this.state.deleteText}
              <img
                className="icon"
                src={require("../../../Images/Icons/delete.svg")}
                alt="trashCan"
              ></img>
            </span>
          )}
        </div>
        <div
          ref={(div) => (this.listElement = div)}
          onMouseDown={this.onDragStartMouse}
          onTouchStart={this.onDragStartTouch}
          className="ListItem"
        >
          {this.firstRow}

          <div ref={(div) => (this.dragArrow = div)} className="redArrow" />
        </div>

        {this.expandedContent}
      </div>
    );
  }
}

export default SwipeableListItem;
